import { api } from "./api.js";

const DEFAULT_ATTEMPTS = 4;
/** Delay before each retry after the first failure (ms). Total wait stays under ~30s. */
const RETRY_DELAYS_MS = [2000, 4000, 8000];

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function provisionOnce(orderId: string): Promise<string | null> {
  try {
    const r = await api<{ ok?: boolean; login_url?: string }>(
      `/api/public/orders/${orderId}/provision`,
      { method: "POST" },
    );
    return r.login_url ?? null;
  } catch {
    return null;
  }
}

/**
 * Provision the new customer via the server -> n8n and return the accessTokenUrl
 * for auto-login. Retries automatically on failure (no UI button). Server-side
 * calls are idempotent. Returns null only after all attempts fail.
 */
export async function provisionAndGetLoginUrl(
  orderId: string,
  attempts = DEFAULT_ATTEMPTS,
): Promise<string | null> {
  for (let i = 0; i < attempts; i++) {
    const loginUrl = await provisionOnce(orderId);
    if (loginUrl) return loginUrl;
    if (i < attempts - 1) {
      await sleep(RETRY_DELAYS_MS[i] ?? RETRY_DELAYS_MS[RETRY_DELAYS_MS.length - 1]!);
    }
  }
  return null;
}
